// removed by extract-text-webpack-plugin
module.exports = {"app-container":"App__app-container___Jpbol"};